<div>
  <div class="status-items">
    <div class="flex justify-between items-center mb-10">
      <span>Websocket State:</span>
      <span>{{ websocketState }}</span>
    </div>
    <div>Websocket URL: {{ websocketUrl }}</div>
    <div>Websocket close URL: {{ closeUrl }}</div>
    <div>Video Server: {{ videoServer }}</div>
    <div class="flex">
      <button mat-raised-button color="warn" (click)="onSimulateFailureClick()">Simulate Failure</button>
      <button mat-raised-button color="accent" (click)="onSimulateCloseClick()">Simulate Close</button>
      <button mat-raised-button color="accent" (click)="onSimulateIncompatibleVersionClick()">
        Simulate Incompatible Version
      </button>
      <mat-checkbox [(ngModel)]="filterStats">filter stats</mat-checkbox>
    </div>
  </div>

  <div>
    <button mat-raised-button color="accent" (click)="requestServerSocketClose()">Request Server Socket Close</button>
    <small
      >requires
      <a href="https://chromewebstore.google.com/detail/allow-cors-access-control/lhobafahddgcelffkeicbaginigeejlf"
        >unblocked CORS</a
      ></small
    >
  </div>

  <h4>Websocket Messages</h4>
  <button mat-raised-button (click)="onCopyWebsocketMessages()">Copy Messages</button>
  <button mat-raised-button (click)="onClearWebsocketMessages()">Clear</button>
  <input
    type="search"
    class="filter-input"
    placeholder="Filter messages"
    [(ngModel)]="filter"
    (ngModelChange)="onFilterChange()"
  />
  <table class="table">
    <thead>
      <tr>
        <th class="timestamp">Timestamp</th>
        <th class="direction">Direction</th>
        <th class="message">Message</th>
      </tr>
    </thead>
    <tbody>
      @for (msg of messageDisplay; track msg) {
        <tr>
          <td>{{ msg.time.split('T')[1] }}</td>
          <td>{{ msg.direction }}</td>
          <td class="message-cell text-overflow-wrap">
            <pre>{{ msg.msg | json }}</pre>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
